require("./src/styles/global.scss");

exports.shouldUpdateScroll = false;